import React from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import ThumbnailCard from './cards/ThumbnailCard';

const FILL_THRESHOLD = 350;

const FilteredCards = ({
  cards,
  page,
  setSelectedCard,
  getCards,
  limit,
  filterKey,
  children,
  t,
}) => {
  return (
    <section className={`page allcards${page === 'Years' ? ' year' : ''}`}>
      <InfiniteScroll
        key={filterKey}
        initialLoad={true}
        pageStart={-1}
        loadMore={getCards}
        hasMore={limit}
        threshold={FILL_THRESHOLD}
        loader={
          <div className="rotate top" key="loader"/>
        }
      >
        {children}
        <div className="columns-wrapper">
          {cards &&
            cards.map((card, i) => (
                <ThumbnailCard
                  key={`${i}-${card._id}`}
                  card={card}
                  setSelectedCard={setSelectedCard}
                  t={t}
                />
            ))}
        </div>
      </InfiniteScroll>
    </section>
  );
};

export default FilteredCards;
